module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo07-77db6c7125df0ba7d06e6c24be65ea67.jpg";